import { clickOutside } from '../directives/clickOutside'
import { clickOutsideNested } from '../directives/clickOutsideNested'
import { canDirective } from '../directives/can'

export default {
    install: (app) => {
        // Register all directives
        app.directive('click-outside', clickOutside)
        app.directive('click-outside-nested', clickOutsideNested)
        app.directive('can', canDirective)

        // Add future directives here
    }
}
